import React from 'react'

import {
  Wrapper,
  Container,
  Track,
  Content,
  TrackDot,
  TrackLine,
} from './styles'

const Timeline: React.FC<any> = ({ children, ...rest }) => (
  <Wrapper {...rest}>{children}</Wrapper>
)

const TimelineContainer: React.FC<any> = ({ children }) => (
  <Container>{children}</Container>
)

const TimelineContent: React.FC<any> = ({
  dot = { color: 'success' },
  children,
}) => (
  <Content>
    <Track>
      <TrackDot color={dot?.color} />
      <TrackLine color={dot?.color} />
    </Track>
    {children}
  </Content>
)

export default Timeline
export { TimelineContent, TimelineContainer }
